import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { NETFLIX_COLORS, NETFLIX_SPACING } from '../theme/netflixTheme';

interface AuthRequiredOverlayProps {
  onOpenLogin: () => void;
  onOpenSignup: () => void;
}

export function AuthRequiredOverlay({ onOpenLogin, onOpenSignup }: AuthRequiredOverlayProps) {
  return (
    <View style={styles.container}>
      <div style={overlayStyle}>
        <View style={styles.modal}>
          <Text style={styles.title}>Faça login para assistir</Text>
          <Text style={styles.subtitle}>
            Crie sua conta para acessar o conteúdo completo
          </Text>

          <View style={styles.buttonsContainer}>
            <TouchableOpacity
              style={styles.primaryButton}
              onPress={onOpenLogin}
            >
              <Text style={styles.buttonText}>Entrar</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.secondaryButton}
              onPress={onOpenSignup}
            >
              <Text style={styles.secondaryButtonText}>Criar Conta</Text>
            </TouchableOpacity>
          </View>
        </View>
      </div>
    </View>
  );
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
  backdropFilter: 'blur(4px)',
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  modal: {
    backgroundColor: NETFLIX_COLORS.surface,
    borderRadius: 16,
    padding: NETFLIX_SPACING.xl * 2,
    maxWidth: 480,
    alignItems: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    color: NETFLIX_COLORS.textPrimary,
    textAlign: 'center',
    marginBottom: NETFLIX_SPACING.sm,
  },
  subtitle: {
    fontSize: 16,
    color: NETFLIX_COLORS.textSecondary,
    textAlign: 'center',
    lineHeight: 24,
    marginBottom: NETFLIX_SPACING.xl,
  },
  buttonsContainer: {
    width: '100%',
    gap: NETFLIX_SPACING.md,
  },
  primaryButton: {
    backgroundColor: NETFLIX_COLORS.primary,
    borderRadius: 8,
    paddingVertical: NETFLIX_SPACING.lg,
    paddingHorizontal: NETFLIX_SPACING.xl,
    width: '100%',
    alignItems: 'center',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    borderRadius: 8,
    borderWidth: 2,
    borderColor: NETFLIX_COLORS.primary,
    paddingVertical: NETFLIX_SPACING.lg,
    paddingHorizontal: NETFLIX_SPACING.xl,
    width: '100%',
    alignItems: 'center',
  },
  buttonText: {
    color: NETFLIX_COLORS.white,
    fontSize: 16,
    fontWeight: '700',
  },
  secondaryButtonText: {
    color: NETFLIX_COLORS.primary,
    fontSize: 16,
    fontWeight: '700',
  },
});
